import React, { useState } from "react";
import Slider from "react-slick";
import { FaAngleLeft } from "react-icons/fa";
import { LuNewspaper } from "react-icons/lu";
import barChart from "./../assets/img/bar-chart 1.png";
import infographic from "./../assets/img/infographic 1.png";
import presentation from "./../assets/img/presentation 1.png";
import MainLayout from "../layout/main";
import { appRoutes, useAppNavigation } from "../router/routes";
import { ApiEndpoints, useApiCall } from "../api";
import { RoleViewSelector } from "../component/roleViewSelector";
import { UserRoles } from "../storage/enums";
import { useRoleColor } from "../helper/roleHelper";
import { SelectOption } from "../component/selectOption";

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 8500,
  rtl: true,
  autoplaySpeed: 1000,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const DashboardPage = () => {
  const { navigate } = useAppNavigation();

  const { mainColor, secondColor } = useRoleColor();
  const [filter, setFilter] = useState("");
  const [[news]] = useApiCall({
    endpoints: ApiEndpoints.about.newsList,
  });
  const filterOptions = [
    { label: "انتظار بررسی", value: "انتظار بررسی" },
    { label: "نیاز به ویرایش", value: "نیاز به ویرایش" },
    { label: "تایید شده", value: "تایید شده" },
    { label: "در انتظار اجرا", value: "در انتظار اجرا" },
  ];
  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec 1 */}
        <div className="bg-white rounded-md relative hidden md:block">
          <div className="flex z-20 flex-row items-center text-sm justify-center gap-2 absolute h-full w-32 rounded-lg bg-primary-light text-white">
            <LuNewspaper size={20} />
            <span>گاهشمار</span>
          </div>
          <div className="bg-white py-2 rounded-lg" dir="ltr">
            <Slider {...settings}>
              {news?.data?.map((item, index) => (
                <div
                  key={index}
                  className="text-nowrap md:text-wrap flex w-100"
                >
                  <div className="flex gap-2 justify-start text-[12px] font-light items-center border-l-2 px-4 border-gray-100">
                    <p className="text-right">{item.text}</p>
                    <span className="w-2 h-2 rotate-45 bg-teal-400 rounded-sm"></span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* sec 2 */}
        <div className="bg-white rounded-xl overflow-hidden">
          <div className=" bg-primary-light p-4 text-white">
            خدمات پر کاربرد
          </div>
          <RoleViewSelector>
            <div userRole={UserRoles.User}>
              <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    برنامه‌ها
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.eventList(""))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">
                          مناسبت ها (ثبت برنامه جدید)
                        </span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.programList({}))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست برنامه ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
                  {/* <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    چند رسانه ای
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaAdd())}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">
                          ثبت تولیدات چند رسانه ای جدید
                        </span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaList)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست تولیدات</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaCards)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">چندرسانه ای کاربران</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div> */}
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    اطلاع رسانی
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.announcement)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">ابلاغیه ها/ تقدیرها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.instruction)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">دستورالعمل ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div userRole={UserRoles.Admin}>
              <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    برنامه‌ها
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.programList({}))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست برنامه‌ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    {/*<SelectOption*/}
                    {/*  label={"وضعیت برنامه"}*/}
                    {/*  value={filter}*/}
                    {/*  options={filterOptions}*/}
                    {/*  onChange={(e) => {*/}
                    {/*     setFilter(e.value);*/}
                    {/*    navigate(appRoutes.adminProgramList(e.value));*/}
                    {/*  }}*/}
                    {/*/>*/}
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.eventList(""))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست مناسبت ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
                {/* <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    چند رسانه
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaList)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست تولیدات</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaCards)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">چندرسانه ای کاربران</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div> */}
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    اطلاع رسانی
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.announcement)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">ابلاغیه ها/ تقدیرها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.instruction)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">دستورالعمل ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div userRole={UserRoles.Sazman}>
              <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    برنامه‌ها
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.programList({}))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست برنامه‌ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    {/*<SelectOption*/}
                    {/*  label={"وضعیت برنامه"}*/}
                    {/*  value={filter}*/}
                    {/*  options={filterOptions}*/}
                    {/*  onChange={(e) => {*/}
                    {/*     setFilter(e.value);*/}
                    {/*    navigate(appRoutes.adminProgramList(e.value));*/}
                    {/*  }}*/}
                    {/*/>*/}
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.eventList(""))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست مناسبت ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
                {/* <div
                  className="h-full  relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    چند رسانه
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaList)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست تولیدات</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaCards)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">چندرسانه ای کاربران</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div> */}
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    اطلاع رسانی
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.announcement)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">ابلاغیه ها/ تقدیرها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.instruction)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">دستورالعمل ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div userRole={UserRoles.SazmanOstan}>
              <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    برنامه‌ها
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.programList({}))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست برنامه‌ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    {/*<SelectOption*/}
                    {/*  label={"وضعیت برنامه"}*/}
                    {/*  value={filter}*/}
                    {/*  options={filterOptions}*/}
                    {/*  onChange={(e) => {*/}
                    {/*     setFilter(e.value);*/}
                    {/*    navigate(appRoutes.adminProgramList(e.value));*/}
                    {/*  }}*/}
                    {/*/>*/}
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.eventList(""))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست مناسبت ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
                {/* <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    چند رسانه
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaList)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست تولیدات</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaCards)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">چندرسانه ای کاربران</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div> */}
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    اطلاع رسانی
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.announcement)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">ابلاغیه ها/ تقدیرها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.instruction)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">دستورالعمل ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div userRole={UserRoles.ModireKol}>
              <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    برنامه‌ها
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.programList({}))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست برنامه‌ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    {/*<SelectOption*/}
                    {/*  label={"وضعیت برنامه"}*/}
                    {/*  value={filter}*/}
                    {/*  options={filterOptions}*/}
                    {/*  onChange={(e) => {*/}
                    {/*     setFilter(e.value);*/}
                    {/*    navigate(appRoutes.adminProgramList(e.value));*/}
                    {/*  }}*/}
                    {/*/>*/}
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.eventList(""))}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست مناسبت ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
                {/* <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    چند رسانه
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaList)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">فهرست تولیدات</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.mediaCards)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">چندرسانه ای کاربران</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div> */}
                <div
                  className="h-full relative rounded-lg"
                  style={{ backgroundColor: secondColor }}
                >
                  <div
                    className="box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
                    style={{ backgroundColor: mainColor }}
                  >
                    اطلاع رسانی
                  </div>
                  <div className="box-list flex flex-col gap-2 pt-20 p-4">
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.announcement)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">ابلاغیه ها/ تقدیرها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                    <div className=" flex justify-between bg-white rounded-lg items-center p-4">
                      <div
                        onClick={() => navigate(appRoutes.instruction)}
                        className="cursor-pointer flex gap-2 items-center  text-sm w-full"
                      >
                        <LuNewspaper />
                        <span className="text-[12px]">دستورالعمل ها</span>
                      </div>
                      <FaAngleLeft />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </RoleViewSelector>
        </div>

        <div className="bg-white rounded-xl overflow-hidden">
          <div className=" bg-primary-light p-4 text-white">در یک نگاه</div>
          <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 gap-6">
            <div
              onClick={() => navigate(appRoutes.statisticalReports)}
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue w-fu; flex justify-between items-center cursor-pointer"
            >
              <div className="flex gap-4 items-center text-sm font-normal">
                <img src={barChart} className="w-12" />
                <span>گزارش‌های آماری</span>
              </div>
              <FaAngleLeft />
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue w-fu; flex justify-between items-center cursor-pointer"
              onClick={() => navigate(appRoutes.report)}
            >
              <div className="flex gap-4 items-center text-sm font-normal">
                <img src={infographic} className="w-12" />
                <span>گزارش‌های نموداری</span>
              </div>
              <FaAngleLeft />
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue w-fu; flex justify-between items-center cursor-pointer"
              onClick={() => navigate(appRoutes.programData)}
            >
              <div className="flex gap-4 items-center text-sm font-normal">
                <img src={presentation} className="w-12" />
                <span>عملکرد و ارزیابی</span>
              </div>
              <FaAngleLeft />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DashboardPage;
